export const userTypes = {
  LOADING_USER: 'LOADING_USER',
  USER_AUTH_SUCCESS: 'USER_AUTH_SUCCESS',
  USER_AUTH_FAILED: 'USER_AUTH_FAILED',
  GET_USER_SUCCESS: 'GET_USER_SUCCESS',
  GET_USER_FAILED: 'GET_USER_FAILED',
  UPDATE_USER_DATA_SUCCESS: 'UPDATE_USER_DATA_SUCCESS',
  UPDATE_USER_DATA_FAILED: 'UPDATE_USER_DATA_FAILED',
  MARK_NOTIFICATIONS_READ: 'MARK_NOTIFICATIONS_READ',
  LOGOUT: 'LOGOUT',
};

export const uiTypes = {
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  SHOW_ALERT: 'SHOW_ALERT',
  HIDE_ALERT: 'HIDE_ALERT',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  LOADING_UI: 'LOADING_UI',
  LOADING_UI_FINISHED: 'LOADING_UI_FINISHED',
};

export const dataTypes = {
  LOADING_DATA: 'LOADING_DATA',
  GET_PROFILE: 'GET_PROFILE',
  GET_POSTS: 'GET_POSTS',
  GET_POST: 'GET_POST',
  CREATE_POST: 'CREATE_POST',
  CREATE_COMMENT: 'CREATE_COMMENT',
  CREATE_COMMENT_REPLY: 'CREATE_COMMENT_REPLY',
  GET_COMMENT_REPLIES: 'GET_COMMENT_REPLIES',
  LIKE_POST: 'LIKE_POST',
  UNLIKE_POST: 'UNLIKE_POST',
  DELETE_POST: 'DELETE_POST',
  DELETE_COMMENT: 'DELETE_COMMENT',
  DELETE_COMMENT_REPLY: 'DELETE_COMMENT_REPLY',
};
